import { ResponsiveTypography } from '../../../../Typography/v3/ResponsiveTypography';
import * as React from 'react';
import styled from 'styled-components';
import { TextLink } from '../../../../TextLink/TextLink';
import cl from 'classnames';
import { useWindowScroll } from 'react-use';
import { environment } from '@doltech/core/lib/environment/environment';
import { ButtonIconSecondary } from '../../../../Button/ButtonIconSecondary/ButtonIconSecondary';
import { IconSystemV2EssentialClose } from '@doltech/icons/SystemV2/IconSystemV2EssentialClose';

const Container = styled.div<{ $height: number }>`
  background: linear-gradient(90deg, rgb(255, 245, 233) 0%, rgb(255, 235, 210) 100%);
  width: 100%;

  position: sticky;
  top: ${(props) => props.$height}px;
  z-index: 202;
  left: 0;
  right: 0;
  transition: transform 0.15s ease-out;

  transform: translateY(0);

  &.hide {
    display: none;
  }
`;

const Content = styled.div`
  padding: 0 16px;

  max-width: 1144px;
  margin: 0 auto;

  display: grid;
  grid-template-columns: 148px minmax(0, max-content) max-content;
  align-items: center;
  gap: 28px;

  img {
    height: 98px;
    object-fit: cover;
  }
`;

const SubContent = styled.div`
  display: inline;

  * {
    display: inline-block;
  }
`;

const SubContentWrapper = styled.div`
  padding: 14px 0;
`;

interface JuniorPromotionBannerProps {
  headerHeight?: number;
}

export const JuniorPromotionBanner = (props: JuniorPromotionBannerProps) => {
  const { y } = useWindowScroll();
  const { headerHeight = 64 } = props;
  const [isOpen, setIsOpen] = React.useState(true);

  React.useEffect(() => {
    if (y > 300 && isOpen) {
      setIsOpen(false);
    }
  }, [y, isOpen]);

  return (
    <Container $height={headerHeight} className={cl('junior-promotion-banner', { hide: !isOpen })}>
      <Content>
        <div>
          <img
            src={
              'https://gqefcpylonobj.vcdn.cloud/directus-upload/7b4d51a1-8959-4dd9-8d25-cfc97856b8e3.png'
            }
            alt="Dol English Junior"
          />
        </div>

        <SubContentWrapper>
          <ResponsiveTypography.Paragraph variant="semi-bold/16-24" color="neutral200">
            Ra mắt chương trình IELTS cấp 2
          </ResponsiveTypography.Paragraph>

          <SubContent>
            <ResponsiveTypography.Paragraph variant="regular/14-20" color="gray180">
              Vào tháng 5 này, DOL ra mắt chương trình <b>dự bị IELTS</b> dành cho học sinh{' '}
              <b>9-15 tuổi</b>, giúp đạt <b>7.0 7.5 8.0 IELTS</b> ở bậc THCS.{' '}
            </ResponsiveTypography.Paragraph>
            <a
              href={`${environment.REACT_APP_DOL_CORP_WEBSITE_HOST_NAME}/ielts-junior`}
              target="_blank"
              rel="noreferrer nofollow"
            >
              <TextLink align="left" color="paper" size="medium" text="Xem thử →" />
            </a>
          </SubContent>
        </SubContentWrapper>
        <ButtonIconSecondary
          buttonStyle="clean"
          size="medium"
          icon={<IconSystemV2EssentialClose />}
          onClick={() => setIsOpen(false)}
          transparent
        />
      </Content>
    </Container>
  );
};
